import {InfoPopupModule} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupModule';
import {IRecodeVAPI, RecodeIntegrator} from '@fantasmagames/slot/src/integration/RecodeIntegrator';
import {RecodeGameAutoplayHandlerModuleEvents} from '@fantasmagames/slot/src/modules/autoplay/recode/RecodeGameAutoplayHandlerModuleEvents';
import {InfoPopupTypes} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupTypes';
import {InfoPopupEvents} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupEvents';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';

export class RecodeInfoPopupModule extends InfoPopupModule {
	protected _vApi: IRecodeVAPI = (window as any).V.API;

	protected setupEvents(): void {
		super.setupEvents();
		this.on(RecodeGameAutoplayHandlerModuleEvents.RECODE_AUTOPLAY_SHOW_POPUP, this.onAutoplayMessage);
	}

	protected onNotEnoughMoneyToSpin(): void {
		if (this.api.isBankingAvailable()) {
			// this._vApi.Core.displayInsufficientFunds(); // Will be deprecated according to Game integration doc.
			this.api.api_showInsufficientFundsDialog(() => {
			}); // Error dialog active false on callback.
		} else {
			super.onNotEnoughMoneyToSpin();
		}
	}

	protected getReasonMessage(reason: string): string {
		switch (reason) {
			case 'none':
			case 'spinCount':
				return '';

			case 'lossLimit':
				return '/n' + this.view.translator.getObject('BaseStrings', 'generic', 'g_LossLimitReached');
			case 'winlimit':
				return '/n' + this.view.translator.getObject('BaseStrings', 'generic', 'g_WinLimitreached');
			default:
				return '';
		}
	}

	protected onAutoplayMessage(eventId: string, message: string, reason?: string): void {
		if (message.length === 0) {
			message = this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplayStopped');
			message += this.getReasonMessage(reason);
		}

		this._currentMessageType = InfoPopupTypes.MESSAGE;
		this.view.showOKMessage(message);
		this.eventManager.emit(InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
	}

	protected get api(): RecodeIntegrator {
		return (this.logic as RecodeLogic).communicator as RecodeIntegrator;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/info/recode/RecodeInfoPopupModule.ts